import { DEFAULT_PAGE_SIZE } from './reviews.constants';

class ReviewsDelegate {
    handleTableChange(pagination) {
        const page = pagination?.current || 1;
        const perPage = pagination?.pageSize || DEFAULT_PAGE_SIZE;
        if (typeof this.loadList === 'function') {
            this.loadList(page, perPage);
        }
    }
}

export default ReviewsDelegate;
